function parseRules(config) {
  if (!config) return []
  try {
    const rules = JSON.parse(config)
    return Array.isArray(rules) ? rules.filter(rule => typeof rule === 'string') : []
  } catch (error) { return [] }
}

export function resolveLoginReturn(value, origin, configuredTargets) {
  if (typeof value !== 'string' || !value) return null
  try {
    let input = value
    // Vue Router already decodes query values. Decode only an encoded URL wrapper.
    if (/^(?:https?%3a|%2f)/i.test(input)) input = decodeURIComponent(input)
    if (/[\u0000-\u0020\\]/.test(input) || /%(?![0-9a-f]{2})/i.test(input) || input.indexOf('//') === 0) return null
    if (input.charAt(0) !== '/' && !/^https?:\/\//i.test(input)) return null
    const base = new URL(origin)
    const target = new URL(input, base.origin)
    if (!/^https?:$/.test(target.protocol) || target.username || target.password) return null
    if (target.origin === base.origin) {
      if (/^\/login\/?$/i.test(target.pathname)) return null
      return target
    }
    const rules = ['https://portal.lechun.cc/'].concat(parseRules(configuredTargets))
    return rules.some(rule => {
      let allowed
      try { allowed = new URL(rule) } catch (error) { return false }
      return allowed.protocol === 'https:' && !allowed.username && !allowed.password &&
        !allowed.search && !allowed.hash && allowed.origin === target.origin && allowed.pathname === target.pathname
    }) ? target : null
  } catch (error) { return null }
}

export function appendLoginDisplayFields(target, user) {
  // Display-only compatibility fields, never proof of authentication.
  const result = new URL(target.href)
  result.searchParams.set('userId', user.userId || '')
  result.searchParams.set('userName', user.userId || '')
  result.searchParams.set('userNick', user.userNick || '')
  return result.href
}
